////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
/////////ASSETS/////////
import Close from '../../../assets/icones/modal/close-circle-white.svg'
import InfoPic from '../../../assets/icones/modal/info-pic.svg'
import Warning from '../../../assets/icones/global/warning-white.svg'

/////////STYLED/////////
const ModalPaperWrapper = styled.div`
	position: absolute;
	max-height: ${(props) => props.maxHeight && `${props.maxHeight}px`};
	overflow-y: auto;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	z-index: ${(props) => (props.critical ? '56' : '20')};
	border-radius: 4px;
	min-width: ${(props) => (props.minWidth > 0 ? `${props.minWidth}px` : '0px')};
	width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : props.minWidth > 0 ? '90%' : props.width ? `${props.width}px` : 'auto')};
	max-width: ${(props) => props.maxWidth && `${props.maxWidth}px`};
	height: ${(props) => (props.maxHeight ? `${props.maxHeight}px` : props.maxHeight > 0 ? '90%' : 'auto')};
`
const ModalHeaderWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-height: 29px;
	max-height: max-content;
	background-color: ${(props) => (props.color ? props.theme.colors[props.color] : props.theme.colors.primary)};
	padding: 11px 13px;
`
export const HeaderTittle = styled.div`
	font-size: ${(props) => props.theme.font.fl};
	color: ${(props) => props.theme.colors.white};
	font-weight: 900;
	cursor: default;
	padding-right: 20px;
	padding-left: 31px;

	background-image: ${(props) => {
		// Revamp of icons handling
		// If props.icon is true, it means that we authorize icon printing
		if (props.icon) {
			// props.color is equal to level in this component
			switch (props.color) {
				case 'error':
					return `url(${Warning})`
				case 'warning':
					return `url(${Warning})`
				default:
					return `url(${InfoPic})`
			}
		}
	}};
	background-repeat: no-repeat;
	background-position: center left;
	background-size: contain;
`
const HeaderTab = styled(Link)`
	text-decoration: none;
	display: inline-flex;
	padding: 10px;
	border: 1px solid ${(props) => props.theme.colors.TabNav.border};
	border-bottom: none;
	color: ${(props) => props.theme.colors.primary};
	border-radius: 4px 4px 0 0;
	z-index: 1;
	background-color: ${(props) => props.theme.colors.white};
	cursor: pointer;
	font-weight: bold;
	margin-bottom: -1px;
`
const CloseImage = styled.img`
	cursor: pointer;
`
const ModalBodyWrapper = styled.div`
	background-color: ${(props) => props.theme.colors.white};
	min-height: min-content;
	max-height: max-content;
	padding: 20px;
`
const CloseModalImg = styled.img`
	position: absolute;
	top: 0;
	right: 5px;
	min-height: 32px;
	min-width: 32px;
	z-index: 25;
	cursor: pointer;
`
/////////STYLED/////////

const ModalPaper = ({ maxHeight, maxWidth, icon, headerTittle, children, color, closeModal, critical, tabTitle = false, minWidth, width }) => {
	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ModalPaperWrapper critical={critical} minWidth={minWidth} maxWidth={maxWidth} maxHeight={maxHeight} width={width}>
			{tabTitle && <HeaderTab>{tabTitle}</HeaderTab>}
			{headerTittle && (
				<ModalHeaderWrapper color={color}>
					<HeaderTittle icon={icon} color={color}>
						{headerTittle}
					</HeaderTittle>
					<CloseImage src={Close} onClick={closeModal} />
				</ModalHeaderWrapper>
			)}
			<ModalBodyWrapper>
				{tabTitle && <CloseModalImg src={Close} onClick={closeModal} />}
				{children}
			</ModalBodyWrapper>
		</ModalPaperWrapper>
	)
}

ModalPaper.propTypes = {}

ModalPaper.defaultPropTypes = {}

export default ModalPaper
